import { Link } from 'react-router-dom'
import { ExternalLink, FileCheck } from 'lucide-react'
import { FinanceSlaBadge } from '@/components/Financeiro/FinanceSlaBadge'
import { formatFinanceStatus } from '@/hooks/useFinanceiroPage'
import type { FinanceRequestDetail } from '@/services/financeService'
import { cn } from '@/utils/cn'

const FINANCE_ACCENT = '#ef4444'

type Props = {
  detail: FinanceRequestDetail
  className?: string
}

export function FinanceRequestDetailHeader({ detail, className }: Props) {
  return (
    <div
      className={cn(
        'glass-card relative overflow-hidden p-5 sm:p-6',
        className,
      )}
    >
      <div
        className='absolute left-0 top-0 h-[2px] w-full'
        style={{
          backgroundImage: `linear-gradient(to right, transparent, ${FINANCE_ACCENT}88, transparent)`,
        }}
      />
      <div className='flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between'>
        <div className='flex min-w-0 gap-4'>
          <div
            className='flex h-12 w-12 shrink-0 items-center justify-center rounded-xl'
            style={{ backgroundColor: `${FINANCE_ACCENT}1a`, color: FINANCE_ACCENT }}
          >
            <FileCheck size={22} aria-hidden />
          </div>
          <div className='min-w-0 space-y-1'>
            <p className='font-mono text-xs font-medium text-text-muted'>{detail.protocol}</p>
            <h2 className='text-xl font-bold tracking-tight text-text-primary sm:text-2xl'>
              {detail.typeLabel}
            </h2>
            <p className='text-sm text-text-muted'>
              Aberto em {new Date(detail.createdAt).toLocaleString('pt-BR')}
              {detail.requester?.name ? ` · ${detail.requester.name}` : ''}
            </p>
            {detail.project?.empresa?.id && (
              <Link
                to={`/clientes/${detail.project.empresa.id}?tab=projetos&projeto=${detail.project.id}&from=financeiro`}
                className='inline-flex items-center gap-1.5 text-sm font-medium text-accent transition-colors hover:underline'
              >
                Ver projeto financeiro
                <ExternalLink size={13} aria-hidden />
              </Link>
            )}
          </div>
        </div>

        <div className='flex flex-wrap items-center gap-2 lg:justify-end'>
          <span
            className={cn(
              'rounded-full border px-3 py-1 text-xs font-semibold',
              'border-white/[0.08] bg-white/[0.04] text-text-primary',
            )}
          >
            {formatFinanceStatus(detail.status)}
          </span>
          <FinanceSlaBadge slaDueAt={detail.slaDueAt} status={detail.status} />
        </div>
      </div>
    </div>
  )
}
